
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (time === null || time === undefined || time === 0 || time === '') {
    return null
  } else if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 60) {
    return '刚刚'
  } else if (diff < 3600) {
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    if (diff > 3600 * 24 * 365) {
      return parseTime(time, '{y}年{m}月{d}日')
    } else {
      return parseTime(time, '{m}月{d}日')
    }
  }
}

export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function throttle(fn, interval) {
  var enterTime = 0; //触发的时间
  var gapTime = interval || 300; //间隔时间，如果interval不传值，默认为300ms
  return function() {
	var that = this;
	var backTime = new Date();
	if(backTime - enterTime > gapTime) {
	  fn.call(that, arguments);
	  enterTime = backTime;
    }
  };
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * isExternalLink: 判断链接是不是外链
 */
export function isExternalLink(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * second2String: 秒转化为x时x分x秒
 * @param {int} second
 * @param {bool} arrReturn false返回字符串 true返回数组
 * @return {string}
 */
export function second2String(second, arrReturn = false) {
  let str = ''
  const arr = []
  if (second > 0) {
    const h = Math.floor(second / 3600)
    if (h > 0) {
      str += h + '时 '
      arr.push([h, '时'])
    }
    const i = Math.floor((second - h * 3600) / 60)
    if (h > 0 || i > 0) {
      str += i + '分 '
      arr.push([i, '分'])
    }
    const s = Math.floor(second - h * 3600 - i * 60)
    if (h > 0 || i > 0 || s > 0) {
      str += s + '秒 '
      arr.push([s, '秒'])
    }
  }
  return arrReturn ? arr : str
}

/**
 * mobileFilter: 手机号隐藏中间四位
 */
export function mobileFilter(mobile = '') {
  if (mobile.length >= 11) {
    return mobile.substr(0, 3) + '****' + mobile.substr(7)
  }
  return ''
}

/**
 * array2Object: 指定键，数组转对象
 */
export function array2Object(arr, key) {
  if (arr.length === 0 || !key) {
    return {}
  } else {
    return arr.reduce((acc, cur) => {
      acc[cur[key]] = cur
      return acc
    }, {})
  }
}

/**
 * byteSize: 数据大小计算
 */
export function byteSize(num) {
  if (!num) return '0 B'
  var k = 1024
  var sizeStr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var i = 0
  for (var l = 0; l < 8; l++) {
    if (num / Math.pow(k, l) < 1) {
      break
    }
    i = l
  }
  return (num / Math.pow(k, i)).toFixed(1) + ' ' + sizeStr[i]
}

/**
 * ssidv1: 生成ssid
 */
export function ssidv1() {
  return '1xxx-xxxx-xxxx-xxxx-xxxx-'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  }) + (+new Date())
}

/**
 * cartesian: 笛卡尔乘积，计算商品sku
 */
export function cartesian(arr) {
  if (arr.length < 2) return arr[0] || []
  return [].reduce.call(arr, function (col, set) {
    let res = []
    col.forEach(c => {
      set.forEach(s => {
        let t = [].concat(Array.isArray(c) ? c : [c])
        t.push(s)
        res.push(t)
      })
    })
    return res
  })
}

export function virtualDebounce (func, wait = 50, immediate = false) {
  let timer = null;
  let result;
  let debounced = function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    if (immediate) {
      let callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (callNow) {
        result = func.apply(this, args)
      }
    } else {
      timer = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    }
    return result;
  }
  debounced.cancel = function () {
    clearTimeout(timer);
    timer = null;
  };
  return debounced;
}


const crypto = require('crypto');

// 配置
const ALGORITHM = 'aes-256-cbc'; // 加密算法
const KEY = process.env.VUE_APP_AES_KEY;// 32 字节密钥
const IV = process.env.VUE_APP_AES_IV; // 16 字节初始化向量

// 加密函数
export function encrypt(text) {
    const cipher = crypto.createCipheriv(ALGORITHM, KEY, IV);
    let encrypted = cipher.update(text, 'binary', 'hex');
    encrypted += cipher.final('hex');
    return encrypted;
}

// 解密函数
export function decrypt(encryptedText) {
    const decipher = crypto.createDecipheriv(ALGORITHM, KEY, IV);
    let decrypted = decipher.update(encryptedText, 'hex', 'binary');
    decrypted += decipher.final('binary');
    return decrypted;
}
